import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type {
  TrainingFollowUpWithUrgenciesVM,
  TrainingFollowUpPaginationParams,
} from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";

export const adminRetrieveTrainingFollowUps = createAsyncThunk<
  PaginatedResult<TrainingFollowUpWithUrgenciesVM>,
  TrainingFollowUpPaginationParams,
  { extra: Partial<Dependencies> }
>("trainingFollowUps/adminRetrieveTrainingFollowUps", async (params: TrainingFollowUpPaginationParams, { extra: { adminRepository } }) => {
  return adminRepository!.adminGetAll(params);
});
